export const meta = {
  id: 'gnome-sort',
  name: 'Gnome Sort',
  category: 'Sorting',
  complexity: {
    time: 'O(n²)',
    space: 'O(1)'
  },
  description: 'Gnome Sort is a simple sorting algorithm that moves forward swapping adjacent elements and moves backward when a swap occurs, like a garden gnome sorting pots.'
};
